import { CSSProperties, useState } from 'react';
import { CheckboxComponent } from '@vivli/shared/components';
import { Color } from '@vivli/shared/theme';
import { DTICommonConst } from '@vivli/shared/infrastructure/constants';
import { ButtonView } from '@vivli/shared/views';

const containerStyle: CSSProperties = {
    padding: 15,
};
const checkboxStyle: CSSProperties = {
    flexDirection: 'row-reverse',
    justifyContent: 'center',
    paddingTop: 10,
    maxWidth: 300,
    marginRight: 0,
    paddingRight: 0,
};
const btnContainerStyle: CSSProperties = {
    padding: '15px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
};

const textStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
};

interface FileUploadWarningComponentProps {
    handleCancel: () => void;
    handleConfirm: () => void;
}

export const FileUploadWarningComponent = ({ handleCancel, handleConfirm }: FileUploadWarningComponentProps) => {
    const [IPDCheck, setIPDCheck] = useState(false);

    return (
        <div style={containerStyle}>
            <div style={textStyle}>
                <div>
                    The Study Documents tab is to be used for supporting documents that will help researchers determine if this study will
                    support their research. This tab must not be used for uploading Individual Participant Data (IPD) since files on this
                    tab are available to any user without placing a request.
                </div>
                <div>
                    If the file you just asked to load contains Individual Participant Data, please click the Cancel button below.
                    Individual Participant Data should be loaded only in the "Data Package" tab. If the file does not contain Individual
                    Participant Data, check "This is not IPD, load this data" and click on OK
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <CheckboxComponent style={checkboxStyle} checked={IPDCheck} onChange={(e) => setIPDCheck(e.target.checked)} />
                <span style={{ marginTop: 20, marginLeft: 0, paddingLeft: 0 }}> This is not IPD, load this data</span>
            </div>
            <div style={btnContainerStyle}>
                <ButtonView onClick={handleConfirm} disabled={!IPDCheck} dataId={DTICommonConst.OkButton}>
                    Ok
                </ButtonView>

                <ButtonView style={{ backgroundColor: Color.VIVLI_RED }} onClick={handleCancel} dataId={DTICommonConst.CancelButton}>
                    Cancel
                </ButtonView>
            </div>
        </div>
    );
};
